import GuestBlogging from 'routes/GuestBlogging'

export default GuestBlogging
